import React from 'react';
import classNames from 'classnames';
import { FloatingPortal, useMergeRefs } from '@floating-ui/react';
import { useToggletipContext } from '../../Toggletip';
import { ToggletipArrow } from '../ToggletipArrow/ToggletipArrow';
import * as styles from './ToggletipContent.module.scss';

export const ToggletipContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement>
>(function ToggletipContent({ style, className, ...props }, propRef) {
  const context = useToggletipContext();
  const ref = useMergeRefs([context.refs.setFloating, propRef]);

  if (!context.open) return null;

  return (
    <FloatingPortal>
      <div
        ref={ref}
        style={{
          ...context.floatingStyles,
          ...style,
        }}
        className={classNames(
          styles.content,
          { [styles.dark]: context.variant === 'dark' },
          className
        )}
        {...context.getFloatingProps(props)}
      >
        <ToggletipArrow />
        {props.children}
      </div>
    </FloatingPortal>
  );
});
